import { memo } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { RedesignSignInWithProviderButton } from 'root/src/client/v2/auth/redesign/RedesignSignInWithProviderButton';
import { Provider } from 'root/src/shared/@types/providers';
import { toast } from 'root/src/client/v2/common/components/ui/sonner';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
export const RedesignReauthModal = memo(({ onSuccess, header, label }) => (<RedesignModalShell className="sm:max-w-md">
		<div className="flex w-full flex-col items-center gap-3 text-center">
			<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-cyan/30 bg-neon-cyan/10">
				<LockOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-cyan"/>
			</div>
			<h2 className="font-display text-xl font-bold text-foreground">{header !== null && header !== void 0 ? header : 'Sign in to continue'}</h2>
			<p className="text-sm text-muted-foreground">{label !== null && label !== void 0 ? label : 'Please re-authenticate your Twitch account to accept this dare.'}</p>
		</div>
		<RedesignSignInWithProviderButton provider={Provider.Twitch} popup popupOptions={{
        onSuccess: () => {
            toast.success('Account successfully refreshed!');
            onSuccess();
        },
        onError: (error) => {
            toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
        },
    }}/>
	</RedesignModalShell>));
// Redesign of the inline Twitch re-auth prompt. Fire-and-forget (matches the legacy show + return).
export const useRedesignReauthModal = () => {
    const modal = useRedesignModal();
    return () => modal.show(<RedesignReauthModal onSuccess={modal.hide}/>);
};
